import { useContext, useEffect } from "react";
import { Routes, Route, BrowserRouter as Router, useLocation } from "react-router-dom";
// import { Routes, Route, HashRouter as Router } from "react-router-dom";
import { ThemeContext } from "./contexts/theme";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Index from "./components/Pages/Index/Index";
import ResumePage from "./components/Pages/Resume/ResumePage";
import NotFound from './components/Pages/NotFound/NotFound';
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import "./App.css";

const HashScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return null;
};

const App = () => {
  const [{ themeName }] = useContext(ThemeContext);

  return (
    <Router basename="/abhinavchat-portfolio">
      <div className={themeName}>
        <Header />
        <div id="top" className="app">
          <HashScrollHandler />
          <Routes>
            <Route index element={<Index />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ScrollToTop />
          <Footer />
        </div>
      </div>
    </Router>
  );
};

export default App;
